// extracted by mini-css-extract-plugin
export default {"container":"GoBack_container__BA3nr","padded":"GoBack_padded__bUVdm","icon":"GoBack_icon__SltMK","back_icon":"GoBack_back_icon__CCOme","primary":"GoBack_primary__g5zLZ"};